import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as actionsUi from './dokument-verwaltung-berechtigungen.actions.ui';
import * as apiBenutzerverwaltung from '../../../../clients/benutzerverwaltung';
import {
    GET_DOKUMENT_BERECHTIGUNG,
    GET_DOKUMENT_BERECHTIGUNG_ERFOLGREICH,
    GET_DOKUMENT_BERECHTIGUNG_FEHLER,
    GetDokumentBerechtigungErfolgreichAction,
} from '../../../../client-ngrx/vorlagen';
import {DokumentBerechtigung} from '../../../../clients/vorlagen';

export interface RolleBenutzerCheckboxWrapper {
    selected: boolean;
    titel: string;
    benutzer: apiBenutzerverwaltung.RolleBenutzer;
}

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    dokumentBerechtigung: DokumentBerechtigung;
    dokumentBerechtigungLaden: boolean;
    dokumentBerechtigungFehler: boolean;
}

export const initialPageState: PageState = {
    dokumentBerechtigung: null,
    dokumentBerechtigungLaden: true,
    dokumentBerechtigungFehler: false
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            // const a = <actionsUi.PageStateResetAction> action;

            return Object.assign({}, state, <PageState>initialPageState);
        }

        // DOKUMENT BERECHTIGUNG LADEN
        case GET_DOKUMENT_BERECHTIGUNG: {
            return Object.assign({}, state, <PageState>{
                dokumentBerechtigungLaden: true,
                dokumentBerechtigungFehler: false
            });
        }

        case GET_DOKUMENT_BERECHTIGUNG_ERFOLGREICH: {
            const a = <GetDokumentBerechtigungErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                dokumentBerechtigung: a.payload,
                dokumentBerechtigungLaden: false,
                dokumentBerechtigungFehler: false
            });
        }

        case GET_DOKUMENT_BERECHTIGUNG_FEHLER: {
            return Object.assign({}, state, <PageState>{
                dokumentBerechtigung: null,
                dokumentBerechtigungLaden: false,
                dokumentBerechtigungFehler: true,
            });
        }

        default: {
            return state;
        }
    }
}


/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('DokumentverwaltungPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getDokumentBerechtigung = createSelector(getPageState, (state: PageState) => state.dokumentBerechtigung);
export const getDokumentBerechtigungLaden = createSelector(getPageState, (state: PageState) => state.dokumentBerechtigungLaden);
export const getDokumentBerechtigungFehler = createSelector(getPageState, (state: PageState) => state.dokumentBerechtigungFehler);
